
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Bei manchen Patienten genügt es, sie zu beraten und anzuleiten. Andere brauchen
einen stationären Entzug, psychologische Betreuung, andere Medikamente und/oder
nicht medikamentöse Therapien wie Biofeedback und Ausdauersport. Bis zu fünf von
zehn Betroffenen mit MOH erleiden einen Rückfall.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;